import { Record } from 'immutable'

export const STATUS = {
  REQUESTED: 0,
  PAID: 1,
  CANCELLED: 2,
  REFUNDED: 3,
  WITHHOLDED: 4,
  EXPIRED: 5,
  PARTIAL_REFUNDED: 6,
  POSTPAY: 7,
  POSTPAY_CANCELLED: 8,
  POSTPAY_REQUESTED: 9,
}

export const PAYMENT_METHOD = {
  NONE: 0,
  BANK: 1,
  CARD: 2,
  ONSITE: 3,
  INVOICE: 4,
  POSTPAY: 5,
  OTHER: 99,
}
